import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

const LoginPage = React.lazy(() =>
  import(/* webpackChunkName: 'LoginPage' */ '@/pages/loginPage')
);
const PasswordRecoveryPage = React.lazy(() =>
  import(/* webpackChunkName: 'PasswordRecoveryPage' */ './content/LoginPage/PasswordRecoveryPage.js')
);


export const routes = [
  {
    // `element` must be a rendered element — handing react-router the lazy
    // component object itself made this route render nothing at all, so the
    // recovery link from the mail opened a blank page.
    path: '/password_recovery/:token',
    element: <PasswordRecoveryPage />,
  },
  {
    path: '*',
    element: <LoginPage />,
  },
];

export default createBrowserRouter(routes);
